import $router from "@/router/index.js"
import $H from "@/utils/request.js"
export default {
	state: {
		menuType: 'left',
		leftMenuList: [],
		topMenuList: [],
		topMenuActive: 0,
		isLoadRoute: false,
		activeTabValue: '/index',
		userInfo: {},
		tabList: [ {title: '首页', name: '/index'}],
		menuList: [],
		yuyueAwaitNum: 0
	},
	mutations: {
		initInfo(state) {
			let menuType = localStorage.getItem("menuType")
			if(menuType) state.menuType = menuType
			let userInfo = localStorage.getItem("userInfo")
			if(userInfo) state.userInfo = JSON.parse(userInfo)
			let tabList = sessionStorage.getItem("tabList")
			if(tabList) state.tabList = JSON.parse(tabList)
			let menuList = sessionStorage.getItem("menuList")
			if(menuList) state.menuList = JSON.parse(menuList)
		},
		setIsLoadRoute(state){
			state.isLoadRoute = true
		},
		addTab(state, tab){
			if(tab.openType && tab.openType != 1) return
			if(tab.meta && tab.meta.openType && tab.meta.openType != 1) return
			let tabList = sessionStorage.getItem('tabList')
			if(tabList == null) tabList = [ {title: '首页', name: '/index'}]
			else tabList = JSON.parse(tabList)
			let path = decodeURI(tab.path)
			let index = tabList.findIndex(v => v.name == path)
			if(index == -1){
				let title = tab.name
				if(tab.meta && tab.meta.name) title = tab.meta.name
				tabList.push({title: title, name: path})
				sessionStorage.setItem('tabList', JSON.stringify(tabList))
				state.tabList = tabList
			}
			state.activeTabValue = path
			if(state.menuType == 'top') {
				setTimeout(()=>{
					let index = selectNowActive(state.topMenuList,state.activeTabValue)
					if(index > -1 && state.topMenuActive != index) {
						state.topMenuActive = index
						this.commit('initLeftMenu')
					}
				},1)
			}
		},
		removeTab(state,tabName){
			let tabList = sessionStorage.getItem('tabList')
			if(tabList == null) tabList = [ {title: '首页', name: '/index'}]
			else tabList = JSON.parse(tabList)
			let index = tabList.findIndex(v => v.name == tabName)
			tabList.splice(index, 1)
			sessionStorage.setItem('tabList', JSON.stringify(tabList))
			state.tabList = tabList
			let path = decodeURI($router.currentRoute.path)
			if(path == tabName) $router.push(state.tabList[index - 1].name)
			if(state.menuType == 'top') {
				setTimeout(()=>{
					let index = selectNowActive(state.topMenuList,state.activeTabValue)
					if(index > -1 && state.topMenuActive != index) {
						state.topMenuActive = index
						this.commit('initLeftMenu')
					}
				},1)
			}
			
		},
		clearLoginInfo(state){
			state.isLoadRoute = false,
			state.userInfo = {}
			state.activeTabValue = '/index',
			state.tabList = [ {title: '首页', name: '/index'}]
			state.menuList = []
			localStorage.removeItem("userInfo")
			localStorage.removeItem("token")
			sessionStorage.clear()
		},
		initTopMenu(state){
			if(state.menuType == 'left') state.topMenuList = []
			else{
				state.topMenuList = state.menuList.slice(1)
				let index = selectNowActive(state.topMenuList,state.activeTabValue)
				state.topMenuActive = index > -1 ? index : 0
			} 
		},
		initLeftMenu(state){
			state.leftMenuList = []
			setTimeout(()=>{
				if(state.menuType == 'left') state.leftMenuList = state.menuList
				else{
					let nowMenuList = state.topMenuList[state.topMenuActive].children
					state.leftMenuList = nowMenuList ? nowMenuList : []
				}
			},1)
		},
		clickTopMenu(state, {index,item}){
			state.topMenuActive = index
			this.commit('initLeftMenu')
			if(item.type == 2) $router.push(item.path)
		},
		changeMenuType(state){
			if(state.menuType == 'left') state.menuType = 'top'
			else state.menuType = 'left'
			localStorage.setItem("menuType", state.menuType)
			this.commit('initTopMenu')
			this.commit('initLeftMenu')
		}
	},
	actions: {
		async getUserInfo({ state }) {
			let userInfo = await $H.get("/admin/fwUser/getUserInfo")
			state.userInfo = userInfo
			localStorage.setItem("userInfo", JSON.stringify(userInfo))
		},
		async getMenuList({state,commit,dispatch}) {
			let menuList = await $H.get("/admin/fwMenu/getMyMenuList")
			state.menuList = menuList
			menuList.unshift({
					name: '首页',
					icon: 'el-icon-s-home',
					path: '/index',
					componentType: 1,
					component: '/index/index',
					type: 2
				})	
			sessionStorage.setItem("menuList", JSON.stringify(menuList))
			state.isLoadRoute = false
			commit("initTopMenu")
			commit("initLeftMenu")
			dispatch('getAwaitHandleNum')
		},
		async getAwaitHandleNum({ state,commit }) {
			let { yuyueAwaitNum } = await $H.get("/admin/fwUser/awaitHandleTipNum")
			state.yuyueAwaitNum = yuyueAwaitNum
			let yuyueMenu = state.menuList.find(v => v.id==162)
			if(yuyueMenu){
				yuyueMenu.badgeVal = yuyueAwaitNum
				let yuyueMenuChild = yuyueMenu.children.find(v => v.id==169)
				if(yuyueMenuChild) yuyueMenuChild.badgeVal = yuyueAwaitNum
			}
			commit("initLeftMenu")
		},
	}
}


function selectNowActive(menuList,path){
	let index = menuList.findIndex(v => {
		if(v.children && v.children.length > 0){
			return selectNowActive(v.children, path) > -1
		}
		return v.path == path
	})
	return index
}
